/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import * as TemplateService from "../../secure/services/templateService";
import * as DocumentService from "../../secure/services/documentService";
import { delay, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/templateActions";
import * as zoneActions from "../actions/zoneActions";
import * as documentActions from "../actions/documentActions";
import * as actionsLoader from "../actions/loaderActions";
import * as UtilsHelper from "../../../utils/utilsHelper";
import i18n from "i18next";
import _ from "underscore";
import AzureFileuploadHelper from "../../../utils/azureFileuploadHelper";
import { StorageHelper } from "../../../utils/storageHelper";

export function* getAllTemplatesSaga(data) {
  try {
    const orgAndViedocResponse =
      yield TemplateService.doFetchOrgAndViedocTemplates(data.payload);
    const studyResponse = yield TemplateService.doFetchStudyTemplates();
    let getAllTemplates = [];
    let orgAndViedoc = orgAndViedocResponse.data.result || [];
    orgAndViedoc.map((res) => {
      getAllTemplates.push(res);
    });
    let study = studyResponse.data.result || [];
    study.map((res) => {
      getAllTemplates.push(res);
    });
    yield put(actions.getAllTemplatesSuccess(getAllTemplates));
  } catch (error) {
    yield put(actions.getAllTemplatesFailed());
  }
}

export function* exportTemplateSaga(data) {
  const { payload } = data;
  try {
    let response = "";
    let reqPayload = { templateId: payload.templateid };

    switch (payload.templatecategory) {
      case "Study template":
        response = yield TemplateService.doExportStudyTemplate(reqPayload);
        break;
      case "TMF Export":
        response = yield TemplateService.doExportTmfTemplate(reqPayload);
        break;
      default: {
        // default case for Organization template and Viedoc System Template
        response = yield TemplateService.doExportOrgAndViedocTemplates(
          reqPayload
        );
        break;
      }
    }

    if (response.status === 500) {
      if (payload.templatecategory === "Study template") {
        yield put(
          actionsLoader.showError(i18n.t("TMF.TOAST_EXPORTTEMPLATEFAILED"), "error", "warning")
        );
      } else if (payload.templatecategory === "TMF Export") {
        yield put(
          actionsLoader.showError(i18n.t("TMF.TOAST_EXPORTSTRUCTUREFAILED"), "error", "warning")
        );
      } else {
        yield put(
          actionsLoader.showError(i18n.t("TMF.TOAST_EXPORTTEMPLATEFAILED"), "error", "warning")
        );
      }
    }


    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      const filename = `${payload.templateName}.xlsx`;
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      yield put(actions.exportTemplateSuccess(payload.templateid));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage), "error", "warning");
    }
  } catch (error) {
    yield put(actions.exportTemplateFailed(payload.templateid));
  }
}

export function* deleteTemplate(data) {
  try {
    let response;
    const { payload } = data;

    if (payload.templateCategory !== "Study template") {
      response = yield TemplateService.doDeleteOrgAndViedocTemplate(
        payload.templateId
      );
    } else {
      response = yield TemplateService.doDeleteStudyTemplate(
        payload.templateId
      );
    }

    if (response.status === 200) {
      const delTemplateData = response.data.result;
      yield put(actions.deleteTemplateSuccess(delTemplateData));
      yield put(zoneActions.fetchMetricsData());
    }
  } catch (error) {
    yield put(actions.deleteTemplateFailed());
  }
}

export function* renameTemplateSaga(data) {
  const { payload, fromCategory, isSelect } = data;
  try {
    let response = {};
    switch (fromCategory) {
      case "Organization template":
        response = yield TemplateService.doRenameOrgTemplate(payload);
        break;
      case "Study template":
        response = yield TemplateService.doRenameStudyTemplate(payload);
        break;
      default:
        break;
    }
    const { isError } = response.data;
    if (!isError) {
      if (isSelect) yield TemplateService.doRenameSelectedTemplate(payload);
      yield put(actions.renameTemplateSuccess(response.data.result));
    } else {
      yield put(actions.renameTemplateFailed());
    }

  } catch (error) {
    yield put(actions.renameTemplateFailed());
  }
}

export function* selectTemplateSaga(data) {
  try {
    let response = "";
    if (data.templatecategory !== "Study template")
      response = yield TemplateService.doSelectTemplate(data.payload);
    else response = yield TemplateService.doSelectStudyTemplate(data.payload);
    if (response.data.isError) {
      yield put(actions.selectTemplateFailed());
    } else {
      yield put(actions.selectTemplateSuccess(response.data));
      yield put(actions.getTMFStructureData("onload"));
    }
  } catch (error) {
    yield put(actions.selectTemplateFailed());
  }
}

export function* instantiateTemplateSaga(data) {
  try {
    const response = yield TemplateService.doInstantiateTemplate(data.payload);
    if (!response.data.isError) {
      yield put(actions.getLockStatus());
      yield put(actions.instantiateTemplateSuccess(response.data));
      yield put(actions.getTMFStructureData());
    } else {
      yield put(
        actionsLoader.showError(
          response.data.responseException.exceptionMessage.title, "error", "warning"
        )
      );
      yield put(actions.instantiateTemplateFailed());
    }
  } catch (error) {
    yield put(actions.instantiateTemplateFailed());
  }
}

export function* generateCompleteAuditTrailSaga(data) {
  try {
    const response = yield TemplateService.doCompleteAuditTrail(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      const { archiveId, status } = result;
      if (!_.isEmpty(archiveId)) {
        yield put(actions.statusCompleteAuditTrail(result));
      } else {
        yield put(actions.generateCompleteAuditTrailFailed());
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.generateCompleteAuditTrailFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("TMF.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* getCompleteAuditTrailSagas(data) {
  const category = data.payload
  try {
    const response = yield TemplateService.doFetchAuditTrailDetail(category);
    const { isError, result } = response.data;
    if (!isError) {
      const { live, latest } = result;
      yield put(actions.getCompleteAuditTrailSuccess(latest, _.isEmpty(live)));
      if (!_.isEmpty(live)) {
        const reqPayload = {
          archiveId: live.id,
        };
        yield put(actions.statusCompleteAuditTrail(reqPayload));
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.getCompleteAuditTrailFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* statusCompleteAuditTrailSaga(data) {
  const { archiveId } = data.payload;
  try {
    if (!_.isEmpty(archiveId)) {
      const response = yield TemplateService.doFetchStatusAuditTrail(archiveId);
      const { isError, result } = response.data;
      if (!isError) {
        yield put(
          actions.generateCompleteAuditTrailSuccess({
            ...data.payload,
            ...result,
          })
        );
      } else {
        const errorMessage = UtilsHelper.constructErrorMsg(response.data);
        yield put(actions.generateCompleteAuditTrailFailed(errorMessage));
        yield put(actionsLoader.showError(errorMessage, "error", "warning"));
      }
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* cancelCompleteAuditTrailSaga(data) {
  try {
    const response = yield TemplateService.doCancelAuditTrail(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      if (data.isStatus) yield put(actions.statusCompleteAuditTrail(result));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.generateCompleteAuditTrailFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* downloadCompleteAuditTrailSaga(data) {
  try {
    let validFilename = UtilsHelper.fileInvalidCharsRemoval(
      data.payload.filename
    );
    data.payload.friendlyFileName = validFilename;
    const response = yield TemplateService.doDownloadAuditTrail(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      let fileurl = atob(result.sastoken);
      const { filename } = data.payload;
      yield AzureFileuploadHelper.downloadAzureFile(fileurl, {
        downloadFileName: UtilsHelper.fileExtensionRemoval(filename),
        type: UtilsHelper.getFileExtension(filename),
      });
      yield put(actions.downloadCompleteAuditTrailSuccess(data.payload.id));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(
        actions.downloadCompleteAuditTrailFailed(errorMessage, data.payload.id)
      );
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("TMF.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* getTimeFormatSaga() {
  try {
    const response = yield TemplateService.doGetTimeFormat();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getTimeFormatSuccess(result));
    } else {
      yield put(
        actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning")
      );
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getLockStatusSaga() {
  try {
    const response = yield TemplateService.getEtmfLockStatus();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getLockStatusSuccess(result));
    } else {
      yield put(actions.getLockStatusFailed());
    }
  } catch (error) {
    yield put(actions.getLockStatusFailed());
  }
}

export function* setetmflock(data) {
  try {
    const response = yield TemplateService.setetmflock(data.payload);
    const { isError, result } = response.data;
    const { issuccess } = result;
    if (!isError) {
      if (issuccess) {
        yield put(actions.setETMFLockSuccess(result));
      } else {
        yield put(
          actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning")
        );
        yield put(actions.setETMFLockFailed());
      }
    } else {
      yield put(
        actionsLoader.showError(
          i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"
        )
      );
      yield put(actions.setETMFLockFailed());
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning")
    );
    yield put(actions.setETMFLockFailed());
  }
}
export function* setetmfunlock(data) {
  try {
    const response = yield TemplateService.setetmfunlock(data.payload);
    const { isError, result } = response.data;
    const { issuccess } = result;
    if (!isError) {
      if (issuccess) {
        yield put(actions.setETMFUnLockSuccess(result));
      } else {
        yield put(
          actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning")
        );
        yield put(actions.setETMFUnLockFailed());
      }
    } else {
      yield put(
        actionsLoader.showError(
          i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"
        )
      );
      yield put(actions.setETMFUnLockFailed());
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning")
    );
    yield put(actions.setETMFUnLockFailed());
  }
}

export function* getEnablingMilestoneStatusSaga() {
  try {
    const response = yield TemplateService.getEnablingMilestoneStatus();
    const { isError } = response.data;
    if (!isError) {
      yield put(
        actions.getEnablingMilestoneStatusSuccess(response.data.result)
      );
    } else {
      yield put(
        actionsLoader.showError(
          i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"
        )
      );
      yield put(actions.getEnablingMilestoneStatusFailed());
    }
  } catch (error) {
    yield put(actions.getEnablingMilestoneStatusFailed());
  }
}

export function* updatingEnablingMilestoneStatusSaga(data) {
  try {
    const response = yield TemplateService.doEnablingMilestoneStatus(
      data.payload
    );
    const { isError } = response.data;
    if (!isError) {
      yield put(actions.updateMileStoneStatusSuccess(response.data.result));
      yield put(actions.getEnablingMilestoneStatus());
    } else {
      yield put(
        actionsLoader.showError(
          i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"
        )
      );
      yield put(actions.updateMileStoneStatusFailed());
    }
  } catch (error) {
    yield put(actions.updateMileStoneStatusFailed());
  }
}

export function* editZoneSaga(data) {
  try {
    const response = yield TemplateService.editZone(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.editZoneSuccess(result));
      yield put(actions.getTMFStructureChanges());
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.editZoneFailed(errorMessage));
    }
  } catch (error) {
    yield put(actions.editZoneFailed(i18n.t("ADMIN.TOAST_EDITZONEFAILED")));
  }
}

export function* editSectionSaga(data) {
  try {
    const response = yield TemplateService.editSection(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.editSectionSuccess(result));
      yield put(actions.getTMFStructureChanges());
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.editSectionFailed(errorMessage));
    }
  } catch (error) {
    yield put(actions.editSectionFailed(i18n.t("ADMIN.TOAST_EDITSECTIONFAILED")));
  }
}

export function* maintenanceOnOffSaga(data) {
  try {
    const response = yield TemplateService.doMaintenanceOnOff(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      const { issuccess, message } = result;
      if (issuccess) {
        yield put(actions.maintenanceOnOffSuccess(result));
        if (data.status !== data.adminStatus) {
          yield put(actions.getTMFStructureChanges());
        }
        yield put(actions.getTMFStructureData());
      } else {
        yield put(actions.maintenanceOnOffFailed());
        yield put(actionsLoader.showError(message, "error", "warning"));
      }
    } else {
      yield put(
        actionsLoader.showError(
          i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"
        )
      );
      yield put(actions.maintenanceOnOffFailed());
    }
  } catch (error) {
    yield put(actions.maintenanceOnOffFailed());
  }
}

export function* maintenanceStatusSaga() {
  try {
    const response = yield TemplateService.getMaintenanceStatus();
    const { isError } = response.data;
    if (!isError) {
      const { message } = response.data.result;
      yield put(actions.maintenanceStatusSuccess(message));
    } else {
      yield put(actions.maintenanceStatusFailed());
    }
  } catch (error) {
    yield put(actions.maintenanceStatusFailed());
  }
}

export function* deleteStructure(data) {
  try {
    const response = yield TemplateService.deleteStruture(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actionsLoader.showError(""));
      yield put(actions.deleteStructureSuccess({ ...data.payload, ...result }));
      yield put(actions.getTMFStructureChanges());
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.deleteStructureFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actions.deleteStructureFailed(i18n.t("ADMIN.TOAST_DELETEFAILED")));
  }
}

export function* getTMFStructureChangesSaga() {
  try {
    const response = yield TemplateService.doTMFStructureChanges();
    const { isError, result } = response.data;
    if (!isError) {
      const { issuccess, message } = result;
      if (!issuccess) {
        yield put(actionsLoader.showError(message, "error", "warning"));
        yield put(actions.getTMFStructureChangesSuccess(result));
      } else {
        yield put(actionsLoader.showError(""));
        yield put(actions.getTMFStructureChangesSuccess(result));
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.getTMFStructureChangesFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(""));
  }
}

export function* getTMFStructureDataSaga() {
  try {
    const response = yield DocumentService.tmfStructureDataService();
    yield put(actions.getTMFStructureDataSuccess(response.data));
    yield put(actions.getMilestoneCount());
  } catch (error) {
    yield put(actions.getTMFStructureDataFailed());
  }
}

export function* getMileStoneCountSaga() {
  try {
    const response = yield DocumentService.getMileStoneCount();
    const { isError } = response.data;
    if (!isError) {
      yield put(
        actions.getMileStoneCountSuccess({
          milestoneCount: response.data.result,
        })
      );
    } else {
      yield put(actions.getMileStoneCountFailed());
    }
  } catch (error) {
    yield put(actions.getMileStoneCountFailed());
  }
}

export function* getTmfStructureDetailsSaga() {
  try {
    const response = yield TemplateService.getTmfStructureDetails();
    const { isError, result } = response.data;

    if (!isError) {
      yield put(actions.getTmfStructDetailsSuccess(result));
    } else {
      yield put(actions.getTmfStructDetailsFailed());
    }
  } catch (error) {
    yield put(actions.getTmfStructDetailsFailed());
  }
}

export function* saveTmfStructureDetailsSaga(data) {
  try {
    const response = yield TemplateService.saveTmfStructureDetails(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.saveTmfStructureDetailsSuccess(result));
      yield put(actions.getTmfStructDetails());
      yield put(actions.getTMFStructureChanges());
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.saveTmfStructureDetailsFailed(errorMessage));
    }
  }
  catch (error) {
    yield put(actions.saveTmfStructureDetailsFailed(i18n.t("TMF.TOAST_SAVEFAILED")));
  }
}
export function* getMilestoneToggleViewHandler(data) {
  try {
    const response = yield TemplateService.getMilestoneToggleView(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      yield put(actions.getMilestoneToggleViewSuccess(result));
    } else {
      yield put(actions.getMilestoneToggleViewFailed());
    }
  } catch (error) {
    yield put(actions.getMilestoneToggleViewFailed());
  }
}
export function* getMilestoneInfoListSaga() {
  try {
    const response = yield TemplateService.getMileStoneList();
    const { isError, result } = response.data;

    if (!isError) {
      yield put(actions.getMilestoneInfoListSuccess(result.viedocmilestonedata));
    } else {
      yield put(actions.getMilestoneInfoListFailed());
    }
  } catch (error) {
    yield put(actions.getMilestoneInfoListFailed());
  }
}

export function* getMileStoneListSaga() {
  try {
    const response = yield TemplateService.doFetchMileStoneList();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getMileStoneListSuccess(result));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getViewZoneSectionArtifactSaga(action) {
  try {
    const response = yield TemplateService.doFetchZoneSectionArtifact(
      action.payload
    );
    const result = {
      from: action.payload.from,
      mode: action.payload.mode,
      ...response.data.result,
    };
    yield put(actions.getViewZoneSectionArtifactSuccess(result));
  } catch (error) {
    yield put(actions.getViewZoneSectionArtifactFailed());
  }
}
export function* addNewArtifactSaga(data) {
  try {
    const response = yield TemplateService.doAddNewArtifact(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      const { issuccess, zone, message } = result;
      if (issuccess && !_.isEmpty(zone)) {
        const reqPayload = {
          zoneList: zone,
          zoneId: data.payload.zone && data.payload.zone.id,
          sectionId: data.payload.section && data.payload.section.id,
          artifactId: data.payload.artifact && data.payload.artifact.id,
          lastmodifiedon: result.lastmodifiedon,
        };
        yield put(actions.addNewArtifactSuccess(reqPayload));
        yield put(actions.getTMFStructureChanges());
      } else {
        yield put(actions.addNewArtifactFailed(message));
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.addNewArtifactFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actions.addNewArtifactFailed(i18n.t("ADMIN.TOAST_ADDNEWARTIFACTFAILED"))
    );
    yield put(actionsLoader.showError(i18n.t("ADMIN.TOAST_ADDNEWARTIFACTFAILED"), "error", "warning"));
  }
}
export function* getDatingConventionListSaga(data) {
  try {
    const response = yield TemplateService.doFetchDatingConventionList();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDatingConventionListSuccess(result));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* revertStructureChangeSaga(data) {
  try {
    const response = yield TemplateService.doRevertStructureChange(
      data.payload
    );
    const { isError, result } = response.data;
    if (!isError) {
      const { issuccess, message } = result;
      if (!issuccess) {
        yield put(actionsLoader.showError(message, "error", "warning"));
        yield put(actions.revertStructureChangeSuccess(result));
        yield put(actions.clearStructureEditChanges());
      } else {
        yield put(actionsLoader.showError(""));
        yield put(actions.clearStructureEditChanges());
        yield put(actions.revertStructureChangeSuccess(result));
        yield put(actions.getTMFStructureData());
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.revertStructureChangeFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actions.revertStructureChangeFailed(i18n.t("ADMIN.TOAST_REVERTFAILED"))
    );
  }
}

export function* applyStructureChangeSaga(data) {
  try {
    const response = yield TemplateService.doApplyStructureChange(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      const { issuccess, message } = result;
      if (!issuccess) {
        yield put(actionsLoader.showError(message, "error", "warning"));
        yield put(actions.applyStructureChangeSuccess(result));
        yield put(actions.clearStructureEditChanges());
      } else {
        yield put(actions.applyStructureChangeSuccess(result));
        yield put(actions.clearStructureEditChanges());

        yield put(
          actionsLoader.showError(
            i18n.t("ADMIN.TOAST_CHANGESAPPLIEDSUCCESS"),
            "info",
            "information"
          )
        );
        yield put(actions.getTMFStructureData());
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
      yield put(actions.applyStructureChangeFailed(errorMessage));
    }
  } catch (error) {
    yield put(actions.applyStructureChangeFailed(i18n.t("ADMIN.TOAST_APPLYFAILED")));
  }
}

export function* getCountryListSaga() {
  try {
    const response = yield TemplateService.getCountryList();

    const { isError, result } = response.data;

    if (!isError) {
      yield put(actions.getCountrySuccess(result));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getSiteListSaga() {
  try {
    const response = yield TemplateService.getSiteList();

    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getSiteSuccess(response.data));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getMilestoneDropDown() {
  try {
    const response = yield TemplateService.getMilestoneDropDownList();
    const { isError } = response.data;
    if (!isError) {
      yield put(actions.getMilestoneDropDownDataSuccess(response.data));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getMilestoneGroupSaga() {
  try {
    const response = yield TemplateService.getMilestoneGroupdata();
    const { isError } = response.data;
    if (!isError) {
      yield put(actions.getMilestoneGroupSuccess(response.data));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getZoneSectionsSaga() {
  try {
    const response = yield TemplateService.getZoneAndSectiondata();

    const { isError } = response.data;

    if (!isError) {
      yield put(actions.getZoneSectionsSuccess(response.data));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning"));
  }
}

export function* getStudyInfoSaga(data) {
  try {
    const response = yield TemplateService.doFetchStudyInfo();
    const { result, isError } = response.data;
    if (!isError) {
      // To find OS, browser name & ip address of user
      let payload = {
        userId: result.userid,
        studyId: result.studyid,
      };
      StorageHelper.setIPAndBrowserDetails({ ...payload });

      // To find studyid & userid of a user
      StorageHelper.setStudyConfig({ ...result });
      StorageHelper.clearRecentSearchInfo();
      //yield put(zoneActions.goToBrowserView());
      yield put(actions.getStudyInformationSuccess(result));
    }
  } catch (error) {
    yield put(actions.getStudyInformationFailed());
  }
}

export function* getSharedDocument(data) {
  try {
    let reqData = data.payload;
    const response = yield TemplateService.getSharedDocument(reqData);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getSharedDocumentSuccess(result));
    } else {
      yield put(actions.getSharedDocumentFailed());
    }
  } catch (error) {
    yield put(actions.getSharedDocumentFailed());
  }
}

export function* fetchDropZoneDocumentsSaga(data) {
  try {
    const response = yield TemplateService.getDropZoneDocuments(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(
        actions.fetchDropZoneDocumentsSuccess(result)
      );
    } else {
      yield put(actions.fetchDropZoneDocumentsFailed());
    }
  } catch (error) {
    yield put(actions.fetchDropZoneDocumentsFailed());
  }
}

export function* getDropZoneSettingsSaga() {
  try {
    const response = yield TemplateService.getDropZoneSettings();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(
        actions.getDropZoneSettingsSuccess(result)
      );
    } else {
      yield put(actions.getDropZoneSettingsFailed());
    }
  } catch (error) {
    yield put(actions.getDropZoneSettingsFailed());
  }
}

export function* doDropZoneFileScreeningSaga(data) {
  const { requestPayload, guid, documentData, index, viewPerPageCount } = data.payload;
  try {
    const fileScreening = yield TemplateService.doDropZoneFileScreening(requestPayload);
    const { isError, result } = fileScreening.data;
    const fileInfo = documentData;
    if (!isError) {
      yield put(actions.getDropZoneFileScreeningStatus(guid, documentData, index, viewPerPageCount));
    } else {
      yield put(actions.resetProgressFileData(fileInfo, "cancelled"));
      documentData.comments = i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD");
      yield put(actions.setInvalidError(documentData));
    }
  } catch (error) {
  }
}

export function* getDropZoneFileScreeningStatusSaga(data) {
  const { fileGuid, fileInfo, loadFrom, viewPerPageCount } = data.payload;

  try {
    const response = yield TemplateService.getDropZoneFileScreening(fileGuid);
    const { isError, result } = response.data;
    const { status, message, statusmessage, dropzoneresult } = result;
    if (!isError && result.status !== "Failed") {
      if (status !== "Imported" && status !== "cancelled") {
        fileInfo.createdon = result.importedon;
        fileInfo.createdby = result.importedby;
        yield put(
          actions.resetProgressFileData(fileInfo, status)
        )
        yield delay(3000);
        yield put(
          actions.getDropZoneFileScreeningStatus(
            fileGuid,
            fileInfo,
          )
        );
      }
      if (status === "Imported") {
        let reqPayload = {
          fileGuid: fileInfo.guid,
          category: fileInfo.category,
          fileName: fileInfo.filename,
          fileExtension: fileInfo.fileextension,
          sizeInBytes: fileInfo.size,
          azureStorageResponse: JSON.stringify(fileInfo.azureData)
        }
        yield put(
          actions.resetProgressFileData(fileInfo, status)
        );
        let lastdocumentupdatedon = sessionStorage.getItem("lastdocumentupdatedon");
        let req = {
          searchKey: "",
          site: "ALL",
          countryCode: "ALL",
          pageCount: 0,
          pageSize: viewPerPageCount || 20000,
          pageNumber: 1,
          artifactId: "",
          sectionid: "",
          category: "",
          milestoneGroup: "ALL",
          milestoneId: "",
          lastdocumentupdatedon: lastdocumentupdatedon
        };
        let recentSearchInfo = StorageHelper.getRecentSearchInfo();
        if (!_.isEmpty(recentSearchInfo)) {
          StorageHelper.setRecentSearchInfo(recentSearchInfo);
        } else {
          StorageHelper.setRecentSearchInfo(req);
        }
        let isFileScan = StorageHelper.getIsAGGridApiRunning();
        if (isFileScan === "false") {
          StorageHelper.setIsAGGridApiRunning(true);
          yield put({ type: "AGGRID_GET_CALL", payload: req });
        }
        yield put(actions.doSaveTMFDropZoneSuccess(dropzoneresult));
        yield put(actions.getDropZoneSettings());
      }
    } else {
      if (status === "Failed") {
        if (statusmessage === "Virus is Found") {
          yield put(actions.resetProgressFileData(fileInfo, "cancelled"));
          fileInfo.comments = i18n.t("TMF.TOAST_FILECONTAINVIRUSMESSAGE");
          yield put(actions.setInvalidError(fileInfo));
          yield put(actions.getDropZoneFileScreeningStatusFailed(fileInfo));
        }
      }
    }
  } catch (error) {
    console.error("Error:", error);
    yield put(actions.getDropZoneFileScreeningStatusFailed(fileInfo));
  }
}

export function* getDropZoneFileScreeningCancelSaga(data) {
  const fileGuid = data.payload.guid;
  try {
    const response = yield fileGuid &&
      TemplateService.doDropZoneFileScreeningCancel({ fileGuid });
  } catch (error) {
    yield put(actions.getDropZoneFileScreeningStatusFailed());
  }
}

export function* deleteDropZoneSaga(data) {
  try {
    yield put(actionsLoader.showLoader());
    const response = yield TemplateService.deleteDropZoneDocument(data.payload.id);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDropZoneSettings());
      yield put(actions.removeDeletedDoc(data.payload));
      yield put(actionsLoader.hideLoader());
      yield put(zoneActions.fetchMetricsData());
      const recentSearchInfo = StorageHelper.getRecentSearchInfo();
      if (!_.isEmpty(recentSearchInfo) && data.payload.searchView === true) {
        //yield put(zoneActions.fetchSearchResult(recentSearchInfo));
      }

      let lastdocumentupdatedon = JSON.parse(sessionStorage.getItem("lastdocumentupdatedon"));
      let req = {
        searchKey: "",
        site: "ALL",
        countryCode: "ALL",
        pageCount: 0,
        pageSize: 20000,
        pageNumber: 1,
        artifactId: "",
        sectionid: "",
        category: "",
        milestoneGroup: "ALL",
        milestoneId: "",
        lastdocumentupdatedon: lastdocumentupdatedon
      };
      if (!_.isEmpty(recentSearchInfo)) {
        StorageHelper.setRecentSearchInfo(recentSearchInfo);
      } else {
        StorageHelper.setRecentSearchInfo(req);
      }
      let currentView = (data.payload.searchView === true) ? false : true;
      let isFileScan = StorageHelper.getIsAGGridApiRunning();
      if (isFileScan === "false") {
        StorageHelper.setIsAGGridApiRunning(true);
        yield put({ type: "AGGRID_GET_CALL", payload: req });
      }

    } else {
      yield put(actions.fetchDropZoneDocumentsFailed());
      yield put(actionsLoader.showError(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"));
      yield put(actionsLoader.hideLoader());
    }
  } catch (error) {
    yield put(actions.fetchDropZoneDocumentsFailed());
  }
}
export const getTemplate = (store) => store.template;

export function* getFileScreeningStatusSaga(data) {
  const { fileGuid, fileInfo, loadFrom } = data.payload;
  try {
    const response = yield TemplateService.doFileScreeningStatus(fileGuid);
    const { isError, result } = response.data;
    if (!isError) {
      const { status, message, statusmessage } = result;
      if (status === "Imported") {
        const updateFileInfo = {
          ...fileInfo,
          loadFrom,
          loadTo: 25,
          loadStatus: result.status,
          responseData: {
            ...response.data,
          },
        };
        yield put(actions.getFileScreeningStatusSuccess(updateFileInfo));
      } else if (status === "Failed") {
        const updateFileInfo = {
          ...fileInfo,
          loadFrom,
          loadTo: 25,
          responseData: {
            isError: true,
            result: {
              status: status,
              responseException: {
                exceptionMessage: result.statusmessage,
              },
            },
          },
        };
        yield put(actions.getFileScreeningStatusFailed(updateFileInfo));
      } else if (status === "cancelled") {
        const updateFileInfo = {
          ...fileInfo,
          loadFrom,
          loadTo: 25,
          loadStatus: result.status,
          responseData: {
            ...response.data,
          },
        };
        yield put(actions.getFileScreeningStatusSuccess(updateFileInfo));
      } else {
        let updateLoadFromTo = {
          loadFrom: loadFrom,
          loadTo: 12,
        };
        if (result.status === "Scanning In-Progress") {
          updateLoadFromTo = {
            loadFrom: loadFrom,
            loadTo: 18,
          };
        }
        if (result.status === "Import In-Progress") {
          updateLoadFromTo = {
            loadFrom: loadFrom,
            loadTo: 22,
          };
        }
        const updateFileInfo = {
          ...fileInfo,
          ...updateLoadFromTo,
          loadStatus: result.status,
          responseData: {
            ...response.data,
          },
        };
        yield put(actions.getFileScreeningStatusSuccess(updateFileInfo));
        yield delay(5000);
        let { isTemplateCancel } = yield select(getTemplate);
        if (!isTemplateCancel) {
          yield put(
            actions.getFileScreeningStatus(
              fileGuid,
              fileInfo,
              updateLoadFromTo.loadTo
            )
          );
        } else {
          yield put(actions.handleTemplateCancel(false));
        }
      }
    } else {
      const updateFileInfo = {
        ...fileInfo,
        responseData: {
          isError: true,
          result: null,
        },
      };
      yield put(actions.getFileScreeningStatusFailed(updateFileInfo));
    }
  } catch (error) {
    yield put(actions.getFileScreeningStatusFailed(fileInfo));
  }
}

export function* getFileScreeningCancelSaga(data) {
  const { fileGuid, fileInfo, loadFrom } = data.payload;
  try {
    const response = yield fileGuid &&
      TemplateService.doFileScreeningCancel({ fileGuid });
    const { isError, result } = response.data;
    if (!isError) yield put(actions.getFileScreeningStatusSuccess(result));
    else yield put(actions.getFileScreeningStatusFailed());
  } catch (error) {
    yield put(actions.getFileScreeningStatusFailed());
  }
}

export function* addNewMilestoneSaga(data) {
  try {
    const response = yield DocumentService.addNewMileStone(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      const { issuccess, message, existingfields } = result;
      if (issuccess) {
        yield put(actions.addNewMilestoneSuccess(result));
        yield put(actions.getMilestoneInfoListSuccess(result.milestones));
        yield put(actions.getMilestoneCount());
        yield put(actions.getTMFStructureChanges());
      } else {
        yield put(
          actions.addNewMilestoneFailed({
            message,
            existingfields,
            formErrorValues: data.payload,
          })
        );
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.addNewMilestoneFailed({ message: i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD") }));
    }
  } catch (error) {
    yield put(actions.addNewMilestoneFailed({ message: i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD") }));
  }
}

export function* editMilestoneSaga(data) {
  try {
    const response = yield DocumentService.doEditMileStone(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      const { issuccess, message, existingfields } = result;
      if (issuccess) {
        yield put(actions.editMilestoneSuccess(result));
        yield put(actions.getMilestoneInfoListSuccess(result.milestones));
        yield put(actions.getTMFStructureChanges());
      } else {
        yield put(
          actions.editMilestoneFailed({
            message,
            existingfields,
            formErrorValues: data.payload,
          })
        );
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.editMilestoneFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
    }
  } catch (error) {
    yield put(actions.editMilestoneFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
  }
}

export function* changeMilestoneSequenceSaga(data) {
  try {
    const response = yield DocumentService.changeMileStoneSequence(
      data.payload
    );
    const { isError, result } = response.data;
    const { issuccess, message } = result;

    if (!isError) {
      if (issuccess) {
        yield put(actions.getMilestoneInfoListSuccess(result.milestones));
        yield put(actions.changeMilestoneSequenceSuccess(result));
        yield put(actions.getTMFStructureChanges());
      } else {
        yield put(actions.changeMilestoneSequenceFailed(message));
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.changeMilestoneSequenceFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
    }
  } catch (error) {
    yield put(actions.changeMilestoneSequenceFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
  }
}

export function* deleteMilestoneSaga(data) {
  try {
    const response = yield DocumentService.doDeleteMileStone(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      const { issuccess, message } = result;
      if (issuccess) {
        yield put(actions.getMilestoneInfoListSuccess(result.milestones));
        yield put(actions.deleteMilestoneSuccess(result));
        yield put(actions.getMilestoneCount());
        yield put(actions.getTMFStructureChanges());
      } else {
        yield put(actions.deleteMilestoneFailed(message));
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.deleteMilestoneFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
    }
  } catch (error) {
    yield put(actions.deleteMilestoneFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
  }
}

export function* getRefreshTokenSaga(data) {
  try {

    const response = yield TemplateService.fetchRefreshToken();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getRefreshTokenSuccess(result));
    } else {
      yield put(actions.getRefreshTokenFailed());
    }


  } catch (error) {
    yield put(actions.getRefreshTokenFailed());
  }

}

export function* cloneNewVersionSaga(data) {
  try {
    const response = yield TemplateService.cloneDocNewVersion(data.payload.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.cloneDocNewVersionSuccess(result));
      yield put(documentActions.getSelectedDocumentDetailSuccess(result.documentdetail));
      yield put(documentActions.getDocNoteSuccess([]));
      yield put(documentActions.doGetDocumentVersionListSuccess(result.documentversionlist));
      if (data.payload?.setdocDetailsList) {
        let result = response.data.result.documentdetail;
        data.payload?.setdocDetailsList({
          ...data.payload?.docDetailsList,
          ...result,
        }); //object update
      }
      yield put(actionsLoader.hideLoader());
    } else {
      yield put(actionsLoader.hideLoader());
    }
  } catch (error) {
    yield put(actions.cloneDocNewVersionFailed())
    yield put(actionsLoader.hideLoader());
  }
}

export function* getdocumentTemplateNamesSaga(data) {
  try {
    const response = yield TemplateService.getDocumentTemplateNames(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocumentTemplateNamesSuccess(result))
    } else {
      yield put(actions.getDocumentTemplateNamesFailed())
    }
  } catch (error) {
    yield put(actions.getDocumentTemplateNamesFailed())
  }
}

export function* etmfSwitchTrackingSaga(data) {
  try {
    const response = yield TemplateService.etmfSwitchTracking(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.etmfSwitchTrackingSuccess(result))
    } else {
      yield put(actions.etmfSwitchTrackingFailed())
    }
  } catch (error) {
    yield put(actions.etmfSwitchTrackingFailed())
  }
}

export function* watchTemplateAsync() {
  yield takeEvery(actionTypes.FETCH_ALL_TEMPLATES, getAllTemplatesSaga);
  yield takeEvery(actionTypes.EXPORT_TEMPLATE, exportTemplateSaga);
  yield takeEvery(actionTypes.DELETE_TEMPLATE, deleteTemplate);
  yield takeEvery(actionTypes.RENAME_TEMPLATE, renameTemplateSaga);
  yield takeEvery(actionTypes.SELECT_TEMPLATE, selectTemplateSaga);
  yield takeEvery(actionTypes.INSTANTIATE_TEMPLATE, instantiateTemplateSaga);
  yield takeEvery(
    actionTypes.GET_VIEW_ZONE_SEC_ARTIF,
    getViewZoneSectionArtifactSaga
  );
  yield takeEvery(
    actionTypes.GET_DATING_CONVENTION_LIST,
    getDatingConventionListSaga
  );
  yield takeEvery(
    actionTypes.REVERT_STRUCTURE_CHANGES,
    revertStructureChangeSaga
  );
  yield takeEvery(
    actionTypes.APPLY_STRUCTURE_CHANGES,
    applyStructureChangeSaga
  );
  yield takeEvery(actionTypes.ADD_NEW_ARTIFACT, addNewArtifactSaga);

  yield takeEvery(
    `${actionTypes.GET_COMPLETE_AUDIT_TRAIL}_INITAL`,
    getCompleteAuditTrailSagas
  );

  yield takeEvery(
    actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL,
    generateCompleteAuditTrailSaga
  );
  yield takeEvery(
    `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_STATUS`,
    statusCompleteAuditTrailSaga
  );
  yield takeEvery(
    `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_CANCEL`,
    cancelCompleteAuditTrailSaga
  );
  yield takeEvery(
    actionTypes.DOWNLOAD_COMPLETE_AUDIT_TRAIL,
    downloadCompleteAuditTrailSaga
  );
  yield takeEvery(
    `${actionTypes.GET_DROP_ZONE_SETTING}`,
    getDropZoneSettingsSaga
  );

  yield takeEvery(
    `${actionTypes.DO_DROP_ZONE_FILESCREENING_STATUS}`,
    doDropZoneFileScreeningSaga
  );

  yield takeEvery(
    `${actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS}_CANCEL`,
    getDropZoneFileScreeningCancelSaga
  );

  yield takeEvery(
    actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS,
    getDropZoneFileScreeningStatusSaga
  );

  yield takeEvery(
    actionTypes.TEMPLATE_FILE_SCREENING_STATUS,
    getFileScreeningStatusSaga
  );

  yield takeEvery(
    `${actionTypes.TEMPLATE_FILE_SCREENING_STATUS}_CANCEL`,
    getFileScreeningCancelSaga
  );

  yield takeEvery(actionTypes.GET_TIME_FORMAT, getTimeFormatSaga);
  yield takeEvery(actionTypes.GET_LOCK_STATUS, getLockStatusSaga);
  yield takeEvery(actionTypes.SET_ETMF_LOCK, setetmflock);
  yield takeEvery(actionTypes.SET_ETMF_UNLOCK, setetmfunlock);

  yield takeEvery(
    actionTypes.GET_ENABLING_MILESTONE_STATUS,
    getEnablingMilestoneStatusSaga
  );
  yield takeEvery(
    actionTypes.UPDATING_ENABLING_MILESTONE_STATUS,
    updatingEnablingMilestoneStatusSaga
  );
  yield takeEvery(actionTypes.EDIT_ZONE, editZoneSaga);
  yield takeEvery(actionTypes.EDIT_SECTION, editSectionSaga);
  yield takeEvery(actionTypes.MAINTENANCE_ON_OFF, maintenanceOnOffSaga);
  yield takeEvery(actionTypes.MAINTENANCE_STATUS, maintenanceStatusSaga);
  yield takeEvery(actionTypes.DELETE, deleteStructure);
  yield takeEvery(
    actionTypes.GET_TMF_STRUCTURE_CHANGES,
    getTMFStructureChangesSaga
  );
  yield takeEvery(actionTypes.TMF_STRUCTURE_DATA, getTMFStructureDataSaga);

  yield takeEvery(actionTypes.GET_MILESTONE_COUNT, getMileStoneCountSaga);

  yield takeEvery(actionTypes.GET_TMF_STRUCTURE, getTmfStructureDetailsSaga);
  yield takeEvery(actionTypes.SAVE_TMF_STRUCTURE, saveTmfStructureDetailsSaga);
  yield takeEvery(actionTypes.GET_MILESTONE_INFO_LIST, getMilestoneInfoListSaga);
  yield takeEvery(
    actionTypes.GET_MILESTONE_VIEW_HANDLER,
    getMilestoneToggleViewHandler
  );
  yield takeEvery(actionTypes.GET_MILESTONE_LIST, getMileStoneListSaga);
  yield takeEvery(actionTypes.GET_COUNTRY_LIST, getCountryListSaga);
  yield takeEvery(actionTypes.GET_SITE_LIST, getSiteListSaga);
  yield takeEvery(
    actionTypes.GET_MILESTONE_DROPDOWN_DATA,
    getMilestoneDropDown
  );
  yield takeEvery(actionTypes.DELETE_DROPZONE, deleteDropZoneSaga);
  yield takeEvery(actionTypes.GET_MILESTONE_GROUP, getMilestoneGroupSaga);
  yield takeEvery(actionTypes.GET_ZONE_SECTION, getZoneSectionsSaga);
  yield takeEvery(actionTypes.GET_SHARED_DOCUMENT, getSharedDocument);
  yield takeEvery(actionTypes.STUDY_INFO, getStudyInfoSaga);
  yield takeEvery(actionTypes.GET_DROP_ZONE_DATA, fetchDropZoneDocumentsSaga);
  yield takeEvery(actionTypes.ADD_NEW_MILESTONE, addNewMilestoneSaga);
  yield takeEvery(actionTypes.EDIT_MILESTONE, editMilestoneSaga);
  yield takeEvery(
    actionTypes.CHANGE_MILESTONE_SEQUENCE,
    changeMilestoneSequenceSaga
  );
  yield takeEvery(actionTypes.DELETE_MILESTONE, deleteMilestoneSaga);
  yield takeEvery(actionTypes.GET_REFRESH_TOKEN, getRefreshTokenSaga);
  yield takeEvery(actionTypes.CLONE_DOC_NEW_VERSION, cloneNewVersionSaga);
  yield takeEvery(actionTypes.GET_DOCU_TEMPLATE_NAMES, getdocumentTemplateNamesSaga);
  yield takeLatest(actionTypes.ETMF_TRACKING, etmfSwitchTrackingSaga);
}
